import { useEffect, useRef, useState, useCallback } from "react";

export function usePoll(fn, interval = 2500, deps = []) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const savedFn = useRef(fn);
  savedFn.current = fn;

  const run = useCallback(async () => {
    try { const d = await savedFn.current(); setData(d); }
    catch (e) { /* keep previous */ }
    finally { setLoading(false); }
  }, []);

  useEffect(() => {
    let alive = true;
    const tick = async () => { if (alive) await run(); };
    tick();
    const t = setInterval(tick, interval);
    return () => { alive = false; clearInterval(t); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  return { data, loading, refresh: run, setData };
}
